

import React from 'react'

import './spinner.css'

const Spinner = () => (
  <div className='spinner'>
    <div className="lds-dual-ring"></div>
  </div>
)

export default Spinner


// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js